import type {
  UpdateDepartmentTypeMutation,
  UpdateDepartmentTypeMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateDepartmentTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUpdateDepartmentType = createMutationHook({
  name: 'updateDepartmentType',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.department.updateType.mutationOptions({ onSuccess }),
  mapInput: (
    variables: UpdateDepartmentTypeMutationVariables
  ): {
    Id: string;
    Name?: string | null;
    Description?: string | null;
    DepartmentTypeGroupId?: string | null;
    // Required for optimistic locking — the repository WHERE clause matches
    // against the previous ModifiedAtTimestamp. Must be the timestamp read
    // back from the record being edited, never a freshly generated one.
    OriginalTimestamp: string;
  } => {
    if (!variables.OriginalTimestamp) {
      throw new Error(
        'OriginalTimestamp is required to update a department type (optimistic locking)'
      );
    }

    return {
      Id: variables.DepartmentTypeId,
      Name: variables.Name,
      Description: variables.Description,
      DepartmentTypeGroupId: variables.DepartmentTypeGroupId,
      OriginalTimestamp: variables.OriginalTimestamp,
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.department.allTypes.queryKey(),
    trpc.frontend.department.departmentTypeById.queryKey(),
    trpc.frontend.department.departmentTypeGroups.queryKey(),
  ],
  mapResponse: (): UpdateDepartmentTypeMutation => ({
    update_department_type: {
      __typename: 'department_type_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateDepartmentTypeDocument,
  graphqlVariables: (variables: UpdateDepartmentTypeMutationVariables) => ({
    ...variables,
  }),
  evictFields: ['department_type', 'department_type_group'],
});
